import { render } from "./ActivityManagementBlock.vue?vue&type=template&id=1050313a"
import script from "./ActivityManagementBlock.vue?vue&type=script&lang=js"
export * from "./ActivityManagementBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/ActivityManagementBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1050313a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1050313a', __exports__)) {
    api.reload('1050313a', __exports__)
  }
  
  module.hot.accept("./ActivityManagementBlock.vue?vue&type=template&id=1050313a", () => {
    api.rerender('1050313a', render)
  })

}


export default __exports__